// One editable lookup list: table of values + add/edit modal. Codes are shown
// read-only; deletion is blocked server-side when in use, so the main lever is
// activate/deactivate.
import { useState } from 'react';
import { settingsApi } from '../../api';
import he from '../../i18n/he';
import { messageForError } from '../../i18n/errors';
import DataTable from '../../components/DataTable';
import Button from '../../components/Button';
import ValueModal from './ValueModal';

export default function ListEditor({ listKey, title, rows, hasDays, hasContext, emptyText, onChanged }) {
  const [editing, setEditing] = useState(null); // row, {} for new, or null

  const toggleActive = async (row) => {
    await settingsApi.update(listKey, row.code, { is_active: row.is_active ? 0 : 1 });
    onChanged();
  };

  const remove = async (row) => {
    try {
      await settingsApi.remove(listKey, row.code);
      onChanged();
    } catch (e) {
      window.alert(messageForError(e));
    }
  };

  const columns = [
    { key: 'code', label: he.settings.code, render: (r) => <span className="muted">{r.code}</span> },
    { key: 'label_he', label: he.settings.label },
    ...(hasDays ? [
      { key: 'due_days', label: he.settings.days, className: 'num' },
      // Where the days count from (075) — שוטף terms from the month's end.
      { key: 'due_basis', label: he.settings.basis, render: (r) => he.settings.bases[r.due_basis] || '—' },
    ] : []),
    ...(hasContext ? [{ key: 'context', label: he.settings.context, render: (r) => he.settings.contexts[r.context] }] : []),
    { key: 'is_active', label: he.settings.active, render: (r) => (
      <span className={`badge ${r.is_active ? 'green' : 'gray'}`}>
        {r.is_active ? he.settings.active : he.settings.inactive}
      </span>
    ) },
    { key: 'actions', label: he.common.actions, render: (r) => (
      <div className="row">
        <Button small variant="subtle" onClick={() => setEditing(r)}>{he.common.edit}</Button>
        <Button small variant="subtle" onClick={() => toggleActive(r)}>
          {r.is_active ? he.settings.deactivate : he.settings.activate}
        </Button>
        <Button small variant="subtle" onClick={() => remove(r)}>{he.common.delete}</Button>
      </div>
    ) },
  ];

  return (
    <div className="card admin-card">
      <div className="admin-card-head">
        <h2>{title}</h2>
        <Button small variant="ghost" onClick={() => setEditing({})}>{he.settings.addValue}</Button>
      </div>
      <DataTable columns={columns} rows={rows} empty={{ text: emptyText }} scroll />
      {editing && (
        <ValueModal
          listKey={listKey}
          hasDays={hasDays}
          hasContext={hasContext}
          value={editing}
          onClose={() => setEditing(null)}
          onSaved={() => { setEditing(null); onChanged(); }}
        />
      )}
    </div>
  );
}
